export default __webpack_public_path__ + "static/expo6-f89f3902f6ba1c398749362793d39d87.jpg";